import { EnrollmentModel, UserModel } from '@descomplica/dex-models';
import { isGreaterThan } from '@/helpers/date';

export const isEnrolledInClassroomAfterPeriodStartDate = (
  user: UserModel,
  dateToCompare: string,
  classroomId: number,
): boolean => {
  return user
    .getStartedEnrollments()
    .some(
      (userStartedEnrollment: EnrollmentModel) =>
        userStartedEnrollment.classroom.id === classroomId &&
        isGreaterThan(userStartedEnrollment.createdAt, dateToCompare),
    );
};

export const checkUserEnrollmentAndTaskByPeriodStart = (
  periodStartDate: string,
  userClassroomEnrollmentDate: string,
  taskStartDate: string,
): boolean => {
  return (
    (isGreaterThan(periodStartDate, userClassroomEnrollmentDate) &&
      isGreaterThan(periodStartDate, taskStartDate)) ||
    (isGreaterThan(userClassroomEnrollmentDate, periodStartDate) &&
      isGreaterThan(taskStartDate, periodStartDate))
  );
};
